import { format, set } from 'date-fns'
import { makeActionCreator } from '../../config/store/utils'
import { extendQuoteClosingDate } from '../../services/quote'

export const CLOSE_QUOTE_EXTEND_CLOSING_DATE_DIALOG = 'CLOSE_QUOTE_EXTEND_CLOSING_DATE_DIALOG'
export const onCloseQuoteExtendClosingDateDialog = makeActionCreator(CLOSE_QUOTE_EXTEND_CLOSING_DATE_DIALOG)

export const OPEN_QUOTE_EXTEND_CLOSING_DATE_DIALOG = 'OPEN_QUOTE_EXTEND_CLOSING_DATE_DIALOG'
export const onOpenQuoteExtendClosingDateDialog = makeActionCreator(OPEN_QUOTE_EXTEND_CLOSING_DATE_DIALOG, 'payload')

export const CLEAN_UP_BUGS_SUCCESS = 'CLEAN_UP_BUGS_SUCCESS'
export const onCleanUpBugsSuccess = makeActionCreator(CLEAN_UP_BUGS_SUCCESS)

export const RESET_CHANGE_DATE_CLOSE_SUCCESS = 'RESET_CHANGE_DATE_CLOSE_SUCCESS'
export const onResetChangeDateCloseSuccess = makeActionCreator(RESET_CHANGE_DATE_CLOSE_SUCCESS)

export const EXTEND_QUOTE_CLOSING_DATE = 'EXTEND_QUOTE_CLOSING_DATE'
export const EXTEND_QUOTE_CLOSING_DATE_ERROR = 'EXTEND_QUOTE_CLOSING_DATE_ERROR'
export const EXTEND_QUOTE_CLOSING_DATE_SUCCESS = 'EXTEND_QUOTE_CLOSING_DATE_SUCCESS'
export const onExtendQuoteClosingDate = makeActionCreator(EXTEND_QUOTE_CLOSING_DATE)
export const onExtendQuoteClosingDateError = makeActionCreator(EXTEND_QUOTE_CLOSING_DATE_ERROR, 'payload')
export const onExtendQuoteClosingDateSuccess = makeActionCreator(EXTEND_QUOTE_CLOSING_DATE_SUCCESS, 'payload')
export const onExtendQuoteClosingDateThunk = payload => async (dispatch, getState) => {
  dispatch(onExtendQuoteClosingDate())

  try {
    const { code } = getState().extendQuoteClosingDateDialog
    const closingDate = format(
      set(payload.date, {
        hours: format(payload.time, 'HH'),
        milliseconds: format(payload.time, 'SSS'),
        minutes: format(payload.time, 'mm'),
        seconds: format(payload.time, 'ss')
      }),
      // FIXME: this format doesn't follow any standard, it should be modified to ISO, RFC or milliseconds.
      'yyyy-MM-dd HH:mm:ss'
    )

    const { data } = await extendQuoteClosingDate({ closingDate, code })

    return dispatch(onExtendQuoteClosingDateSuccess({ data: data?.success }))
  } catch (error) {
    const errors = error.originalError.response.data.errores.map(error => ({
      code: error.codigo,
      description: error.descripcion
    }))

    return dispatch(onExtendQuoteClosingDateError({ errors }))
  }
}
